import { z } from 'zod'

export const typeUserViewScheduleEnum = z.enum(['THERAPIST', 'PATIENT'])

export type TypeUserViewScheduleEnum = z.infer<typeof typeUserViewScheduleEnum>
